module.exports = __webpack_public_path__ + "img/IMG_0300_L_Foamcore.1cc9e056.jpg";